/* eslint-disable @typescript-eslint/no-explicit-any */

import { GamoraErrorNotImplemented } from '../../errors/index.js';

/**
 * A constructor type with args
 * @internal
 * @remarks
 * Please the use fromSyntax to construct
 */
export type GamoraFoundationGuardConstructorType<T, TArgType = any> = {
  new (args: TArgType): T;
};

/**
 * GamoraFoundationGuard
 *
 * Abstract class that guards an input type with strong type checks
 * @public
 */
export abstract class GamoraFoundationGuard<TInput = any> {
  constructor() {
    return;
  }

  /**
   * Constructs Guard from JSON input
   * @param input - The JSON input
   */
  static fromJSON(input: unknown, options: any): any {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Constructs Guard from base64
   * @param input - The base64 input
   */
  static fromBase64(input: unknown, options: any): any {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Constructs Guard from base64URL
   * @param input - The base64URL input
   */
  static fromBase64URL(input: unknown, options: any): any {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Constructs Guard from UTF8
   * @param input - The UTF8 input
   */
  static fromUTF8(input: unknown, options: any): any {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Constructs Guard from HEX
   * @param input - The HEX input
   */
  static fromHex(input: unknown, options: any): any {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Constructs Guard from Empty
   */
  static Empty(): any {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Exports guard to a JSON object
   */
  toJSON(options: any = {}): TInput {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Export to base64URL
   */
  toBase64URL(options: any = {}): string {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Export to toBase64
   */
  toBase64(options: any = {}): string {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Export to utf8
   */
  toUTF8(options: any = {}): string {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Export to Hex
   */
  toHex(options: any = {}): string {
    throw new GamoraErrorNotImplemented();
  }

  /**
   * Create clone
   */
  clone(options: any = {}): GamoraFoundationGuard<TInput> {
    throw new GamoraErrorNotImplemented();
  }
}
